import React, { lazy, Suspense } from 'react';
import ProtectedRoute from '../../shared/components/ProtectedRoute';
import LoadingSpinner from '../../shared/components/LoadingSpinner';

// Lazy load schedule components
const ScheduleList = lazy(() => import('../../routes/schedule/list'));

/**
 * Schedule feature routes with lazy loading
 */
export const scheduleRoutes = [
  {
    path: '/schedule/:poolCode/:livestockTypeId',
    element: (
      <ProtectedRoute requiredRoles={['LMS.Schedule']}>
        <Suspense fallback={<LoadingSpinner message="Loading schedule..." />}>
          <ScheduleList />
        </Suspense>
      </ProtectedRoute>
    ),
  },
];

export default scheduleRoutes;

